import React from 'react';
import RenderRevisionNodes from '../../../Documents/components/RenderRevisionNodes';

/**
 * DeleteNewPreview Component
 * Shows how the document will look after deletion
 */
const DeleteNewPreview = ({ originalData, deleteDocument, newData }) => {
  if (!newData || !deleteDocument) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '40px',
        color: '#666'
      }}>
        <p>Loading new document preview...</p>
      </div>
    );
  }

  return (
    <div>
      <RenderRevisionNodes
        partRef={deleteDocument.partId}
        procedureRevRef={deleteDocument.revisionId}
        partNumber={deleteDocument.partNumber}
        revision={deleteDocument.revision}
        disabled={true}
        showCheckbox={false}
        preloadedData={newData}
        forceShowChildHeadings={true}
      />
    </div>
  );
};

export default DeleteNewPreview;

